import { createPortal } from 'react-dom';
import styled from 'styled-components';
import SidebarTemplate from './sidebarElements/SidebarTemplate';
import { useProject } from '@contexts/Project.context';

const TableHeader = styled.div`
	padding: 10px 20px 0;
	scrollbar-gutter: stable;
	overflow-y: hidden;
`;

const TableWrapper = styled.div`
	padding: 0 20px 20px;
	overflow-y: auto;
	max-height: 300px;
	scrollbar-gutter: stable;
`;

const CompactTable = styled.table`
	width: 100%;
	font-size: 0.85em;
	border-collapse: collapse;
	table-layout: fixed;

	th,
	td {
		padding: 6px 8px;
		text-align: left;
		border-bottom: 1px solid ${({ theme }) => theme.colors.border || '#333'};
	}

	th:nth-child(1),
	td:nth-child(1) {
		width: 60%;
	}

	th:nth-child(2),
	td:nth-child(2) {
		width: 22%;
	}

	th:nth-child(3),
	td:nth-child(3) {
		width: 18%;
	}

	th {
		font-weight: 500;
		color: ${({ theme }) => theme.colors.textAccent};
	}

	td {
		color: ${({ theme }) => theme.colors.textColor};
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
`;

export const DSP_DETECTIONS_SIDEBAR_ID = 'dspDetectionsPerPlot';

const DspDetectionsPerPlotSidebar = ({ perClassPerPlot }) => {
	const { modifyLayersSidebarRef } = useProject();

	if (!perClassPerPlot?.length || !modifyLayersSidebarRef?.current) return null;

	return createPortal(
		<SidebarTemplate
			zindex={2}
			sidebarId={DSP_DETECTIONS_SIDEBAR_ID}
			header="Detections per Plot"
			closeable={true}>
			<TableHeader>
				<CompactTable>
					<thead>
						<tr>
							<th>Plot</th>
							<th>Class</th>
							<th>Count</th>
						</tr>
					</thead>
				</CompactTable>
			</TableHeader>
			<TableWrapper>
				<CompactTable>
					<tbody>
						{perClassPerPlot.map(plot =>
							plot.classes.map((cls, idx) => (
								<tr key={`${plot.plotFilename}-${cls.className}-${idx}`}>
									{idx === 0 && (
										<td rowSpan={plot.classes.length} title={plot.plotFilename}>
											{plot.plotFilename}
										</td>
									)}
									<td>{cls.className}</td>
									<td>{cls.count}</td>
								</tr>
							))
						)}
					</tbody>
				</CompactTable>
			</TableWrapper>
		</SidebarTemplate>,
		modifyLayersSidebarRef.current
	);
};

export default DspDetectionsPerPlotSidebar;
